import { render, staticRenderFns } from "./side-bar-franchise.vue?vue&type=template&id=267e976e"
import script from "./side-bar-franchise.vue?vue&type=script&lang=js"
export * from "./side-bar-franchise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports